import type { PoiCategory } from '$lib/components/pois/types';

export const datasheetSEOPoiCategories = [
	'ACCOMMODATION',
	'TOURISM',
	'RESTAURANT',
] satisfies PoiCategory[];

/** Poi Category that can appear in a datasheet and referenced from SEO */
export type DatasheetSEOPoiCategory = (typeof datasheetSEOPoiCategories)[number];

export function isDatasheetSEOPoiCategory(
	category: PoiCategory,
): category is DatasheetSEOPoiCategory {
	return datasheetSEOPoiCategories.includes(category as DatasheetSEOPoiCategory);
}
